<template>
  <LoaderComponent
    v-if="isLoadingIntegration || getSortIntegrations === 'await'"
  />
  <div v-else>
    <IntegrationList />
  </div>
</template>
<script lang="ts">
import IntegrationList from "./IntegrationList.vue";
import {defineComponent} from "vue";
import type {
  integratioObj,
  integration,
  integrationList
} from "./IntegrationTypes";
import LoaderComponent from "@/elements/UI/overlay/Loader/LoaderComponent.vue";
import {API} from "@/api/generated.js";
export default defineComponent({
  name: "IntegrationComponent",

  components: {
    LoaderComponent,
    IntegrationList
  },
  data() {
    return {
      integrationSnapshot: "",
      isSavingIntegration: false,
      isLoadingIntegration: true
    };
  },
  async mounted() {
    try {
      await this.setData();
    } finally {
      this.isLoadingIntegration = false;
    }
  },
  methods: {
    async setData(integration: integratioObj | null = null): Promise<void> {
      await this.$integrationStore.fetchIntegrations(integration);
      this.integrationSnapshot = this.serializeIntegrationPayload(
        this.getIntegration
      );
    },
    async saveData(newObj: object) {
      this.isSavingIntegration = true;

      try {
        const res = await API.updateIntegration({body: newObj});
        await this.setData(res);
      } catch (error) {
        console.error("Ошибка при сохранении интеграций:", error);
      } finally {
        this.isSavingIntegration = false;
      }
    },
    getIntegrationPayload(integration: integrationList): integratioObj {
      return Object.fromEntries(
        Object.entries(integration).map(
          ([key, value]: [string, integration]) => [key, value.integration]
        )
      );
    },
    serializeIntegrationPayload(integration: integrationList): string {
      return JSON.stringify(this.getIntegrationPayload(integration));
    }
  },
  computed: {
    getIntegration(): integrationList {
      return this.$integrationStore.getIntegration;
    },
    getIntegrationsStr() {
      return this.serializeIntegrationPayload(this.getIntegration);
    },
    getIntegrationName() {
      return this.$integrationStore.getIntegrationName;
    },
    getSortIntegrations() {
      return this.$integrationStore.getSortIntegrations;
    }
  },

  watch: {
    getIntegrationsStr(data) {
      if (!this.integrationSnapshot || this.isSavingIntegration) {
        return;
      }

      if (data !== this.integrationSnapshot) {
        void this.saveData(this.getIntegrationPayload(this.getIntegration));
      }
    }
  }
});
</script>
